<div class="pc-page-shell">
<div class="filter-container" [class.open]="isFilterOpen">
  <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">

    <div class="filter-header">
      <div class="filter-header__title">
        <mat-icon aria-hidden="true">filter_alt</mat-icon>
        <span>Table Filter</span>
      </div>
      <mat-icon class="close-btn" (click)="closeFilterDrawer()">close</mat-icon>
    </div>

    <!-- Body -->
    <form [formGroup]="filterForm" class="filter-body">

      <!-- Date Range -->
      <div class="filter-section">
        <h4>Date Range</h4>

        <app-custom-date-picker
          [label]="'From Date'"
          [controlname]="filterForm.controls['from_date']">
        </app-custom-date-picker>

        <app-custom-date-picker
          [label]="'To Date'"
          [controlname]="filterForm.controls['to_date']">
        </app-custom-date-picker>
      </div>

      <!-- Segment -->
      <div class="filter-section">
        <h4>Segment</h4>

        <app-pc-multi-select-filter
          label=""
          placeholder="Select Segment"
          allLabel="All"
          [options]="segmentOptions"
          [lightMode]="!isDarkMode()"
          [(selected)]="selectedSegments">
        </app-pc-multi-select-filter>
      </div>

      <!-- Ship Details -->
      <div class="filter-section" *ngIf="subusername !== 'demo'">
        <h4>Ship Details</h4>

        <label
          class="shipNameLabel"
          [ngClass]="{ 'dark-label': isDarkMode() }">
          Ship Name
        </label>

        <input
          type="text"
          class="form-control"
          id="shipName"
          formControlName="shipName"
          (input)="filterShipNames($event)"
          [matAutocomplete]="autoShip"
        />

        <mat-autocomplete #autoShip="matAutocomplete">
          <mat-option
            *ngFor="let ship of shipNameSuggestions"
            [value]="ship.shipName">
            {{ ship.shipName }}
          </mat-option>
        </mat-autocomplete>

        <app-custom-input
          placeholder="I.M.O Number"
          label="I.M.O Number"
          [controlname]="filterForm.controls['imoNumber']">
        </app-custom-input>
      </div>

    </form>

    <!-- Footer -->
    <div class="filter-footer">
      <button
        type="button"
        class="btn clear-btn"
        (click)="clearClick()">
        <mat-icon>clear_all</mat-icon>
        Clear Filter
      </button>

      <button
        type="button"
        class="btn apply-btn"
        (click)="filterClick()">
        <mat-icon>filter_list</mat-icon>
        Apply Filter
      </button>
    </div>

  </div>
</div>
<div class="filter-overlay" *ngIf="isFilterOpen" (click)="closeFilterDrawer()"></div>

<div class="container pc-performance-page">
  <header class="pc-page-header">
    <p class="title pc-page-header__title">
      Port Performance<mat-icon class="titleIcon">chevron_right</mat-icon> Charter Party Performance
      <mat-icon class="titleIcon">chevron_right</mat-icon> Charter Party Performance Inside View
    </p>
    <div class="pc-page-header__actions">
      <app-back-button (back)="goBack()"></app-back-button>
      <button
        type="button"
        class="pc-page-header__filter-btn"
        (click)="isFilterOpen = true"
        matTooltip="Table Filter"
        aria-label="Open table filters"
      >
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </header>

  <div class="vessel-detail-header" [ngClass]="{ 'vessel-detail-header--dark': isDarkMode() }">
    <div class="vessel-detail-header__intro">
      <mat-icon class="vessel-detail-header__icon" aria-hidden="true">directions_boat</mat-icon>
      <div>
        <p class="vessel-detail-header__eyebrow">Selected Vessel</p>
        <h3 class="vessel-detail-header__title">{{ vesselHeaderName || '—' }}</h3>
      </div>
    </div>
    <div class="vessel-detail-header__meta">
      <div class="vessel-detail-header__item">
        <span class="vessel-detail-header__label">IMO Number</span>
        <span class="vessel-detail-header__value">{{ vesselHeaderImo || '—' }}</span>
      </div>
      <div class="vessel-detail-header__divider" aria-hidden="true"></div>
      <div class="vessel-detail-header__item">
        <span class="vessel-detail-header__label">Segment</span>
        <span class="vessel-detail-header__segment">{{ vesselHeaderSegment || '—' }}</span>
      </div>
    </div>
  </div>

  <div class="pc-performance-table-stack">
  <div class="table-view-banner table-view-banner--nested view-active">
    <mat-icon>list</mat-icon>
    <div class="banner-copy">
      <span class="banner-title">Charter Party Port Detail</span>
    </div>
    <span class="banner-count">{{ length || 0 }} records</span>
  </div>
  <div class="detail-rail-table-wrapper pc-performance-table-wrapper pc-performance-table-wrapper--nested">
  <div
    class="detail-rail-table-scroll table-container scroll-bar pc-performance-table-scroll pc-data-table"
    [class.pc-data-table--dark]="isDarkMode()"
  >
    <table
      class="pc-performance-table mat-elevation-z8 printable-table"
      #table
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead class="sticky-header">
        <tr>
          <th rowspan="2" class="th-narrow">Sr No</th>
          <th rowspan="2" class="th-medium">Port</th>
          <th rowspan="2" class="th-narrow">Voyage</th>
          <th rowspan="2" class="th-narrow">Cargo</th>
          <th rowspan="2" class="th-medium">Operation</th>
          <th rowspan="2" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Arrival</span>
              <mat-icon class="pc-col-header__info" matTooltip="Arrival Date &amp; Time">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Departure</span>
              <mat-icon class="pc-col-header__info" matTooltip="Departure Date &amp; Time">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-narrow">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Days</span>
              <mat-icon class="pc-col-header__info" matTooltip="Total Time (Days)">info</mat-icon>
            </span>
          </th>
          <th colspan="3" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Fuel Actual (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Actual Consumption by fuel type (MT)">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Total (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Total Consumption (MT)">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">CP Warranted (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="C/P Warranted Consumption (MT)">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">CP Gain/Loss (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Loss or Gain as per Charter Party (MT)">info</mat-icon>
            </span>
          </th>
          <th colspan="3" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Ops Actual (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Actual Consumption by operation phase (MT)">info</mat-icon>
            </span>
          </th>
          <th colspan="3" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">CP Ops (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="C/P Warranted Consumption by operation phase (MT)">info</mat-icon>
            </span>
          </th>
          <th colspan="3" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Ops Gain/Loss (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Loss or Gain by operation phase (MT)">info</mat-icon>
            </span>
          </th>
        </tr>
        <tr>
          <th class="th-fuel">HSFO</th>
          <th class="th-fuel">VLSFO</th>
          <th class="th-fuel">MGO</th>
          <th class="th-narrow">Idle</th>
          <th class="th-medium">Cargo Ops</th>
          <th class="th-medium">Maneuvering</th>
          <th class="th-narrow">Idle</th>
          <th class="th-medium">Cargo Ops</th>
          <th class="th-medium">Maneuvering</th>
          <th class="th-narrow">Idle</th>
          <th class="th-medium">Cargo Ops</th>
          <th class="th-medium">Maneuvering</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let element of paginatedData; let i = index">
          <td>{{ getRowSerialNumber(i) }}</td>
          <td>{{ element.port || '__' }}</td>
          <td>{{ element.voyage || '__' }}</td>
          <td>{{ formatCargoQty(element.cargo_quentity) }}</td>
          <td>{{ element.operation || '__' }}</td>
          <td>{{ element.arrival ? formatPortDate(element.arrival, element.port) : '__' }}</td>
          <td>{{ element.departure ? formatPortDate(element.departure, element.port) : '__' }}</td>
          <td>{{ element.totalTime || '__' }}</td>

          <td>{{ formatMt(element.actualConsumption?.HSFO, true) }}</td>
          <td>{{ formatMt(element.actualConsumption?.VLSFO) }}</td>
          <td>{{ formatMt(element.actualConsumption?.MGO) }}</td>

          <td>{{ formatDecimal(getTotalActualConsumption(element)) }}</td>
          <td>{{ formatDecimal(getTotalCpConsumption(element)) }}</td>
          <td [ngStyle]="{ color: getLossGainColor(element) }">
            {{ formatLossGainMt(getTotalLossGain(element)) }}
          </td>

          <td>{{ formatMt(element.actualOps?.idle) }}</td>
          <td>{{ formatMt(element.actualOps?.cargo_ops) }}</td>
          <td>{{ formatMt(element.actualOps?.maneuvering) }}</td>

          <td>{{ formatMt(element.cpOps?.idle) }}</td>
          <td>{{ formatMt(element.cpOps?.cargo_ops) }}</td>
          <td>{{ formatMt(element.cpOps?.maneuvering) }}</td>

          <td [ngStyle]="{ color: getPerformanceDiffColor(getOpsLossGain(element.cpOps?.idle, element.actualOps?.idle)) }">
            {{ formatDecimal(getOpsLossGain(element.cpOps?.idle, element.actualOps?.idle)) }}
          </td>
          <td [ngStyle]="{ color: getPerformanceDiffColor(getOpsLossGain(element.cpOps?.cargo_ops, element.actualOps?.cargo_ops)) }">
            {{ formatDecimal(getOpsLossGain(element.cpOps?.cargo_ops, element.actualOps?.cargo_ops)) }}
          </td>
          <td [ngStyle]="{ color: getPerformanceDiffColor(getOpsLossGain(element.cpOps?.maneuvering, element.actualOps?.maneuvering)) }">
            {{ formatDecimal(getOpsLossGain(element.cpOps?.maneuvering, element.actualOps?.maneuvering)) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
  <mat-paginator
    class="pc-performance-paginator"
    [length]="length"
    [pageSizeOptions]="[]"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    [hidePageSize]="true"
    showFirstLastButtons
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
  ></mat-paginator>
  </div>
  <br />
  <br />
</div>
</div>
